
export class RecallCategory {
    id: number;
    recallCategoryName: string;
    status: boolean;
}